<app-landing-toolbar></app-landing-toolbar>
<div id="reset-wrapper" class="primary-background-gradient">
    <mat-card>
        <form [formGroup]="resetForm" (submit)="onSubmit()">
            <mat-form-field class="full-width">
                <mat-label>New Password</mat-label>
                <input formControlName="password" matInput type="password" required>
            </mat-form-field>
            <mat-form-field class="full-width">
                <mat-label>Confirm Password</mat-label>
                <input formControlName="confirmPassword" matInput type="password" required>
            </mat-form-field>
            <div *ngIf="resetForm.controls['confirmPassword'].errors?.controlValueIsSame && !resetForm.pristine">
                <mat-error>New password fields do not match.</mat-error>
            </div>
            <button class="full-width" mat-raised-button color="accent" type="submit" gtagEvent trackOn="click" action="password_changed" category="accounts">Change Password</button>
            <div class="full-width" id="error">
                <mat-error *ngIf="error">{{ error }}</mat-error>
            </div>
        </form>
    </mat-card>
</div>
